import styled from 'styled-components';

type ButtonProps = {
  selected?: boolean;
  disabled?: boolean;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const AvailabilitiesButton = styled.button<ButtonProps>`
  margin-bottom: 10px;
  && {
    background-color: ${({ selected, disabled }) =>
      selected && !disabled ? '#286090' : '#46a5c8'};
    background-color: ${({ selected, disabled }) =>
      selected && !disabled ? '#204d74' : '#46a5c8'};
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  padding: 10px;
`;

const AvailabilitiesContainer = styled.div`
  display: flex;
  width: inherit;
  overflow: hidden;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
`;

const ExistingBookingOption = styled(AvailabilitiesButton)`
  width: 100%;
`;

const S = {
  Container,
  AvailabilitiesButton,
  Row,
  AvailabilitiesContainer,
  ExistingBookingOption,
};

export default S;
